import { FC, memo, useRef } from 'react'

import clsx from 'clsx'
import { useHoverDirty } from 'react-use'
import styled, { css } from 'styled-components'

import { Txt } from 'src/components/atoms'

const Container = styled.div<{ isActive: boolean; size: 's' | 'm' }>`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  cursor: pointer;
  border-radius: ${({ size }) => (size === 's' ? '2.86rem' : '3.56rem')};

  ${props =>
    props.isActive &&
    css`
      cursor: default;
    `}
`

const StyledTxt = styled(Txt)<{ isActive: boolean; isHovering: boolean; size: 's' | 'm' }>`
  font-weight: bold;
  padding: 0 ${props => (props.size === 's' ? '1.4rem' : 'var(--s1)')};
  transition: 0.2s ease-in-out;
`

type Props = {
  text: string
  size: 's' | 'm'
  isSelected: boolean
  onClick?: () => void
  className?: string
}

export const Tab: FC<Props> = memo(({ text, size, isSelected, onClick, className }) => {
  const ref = useRef(null)
  const isHovering = useHoverDirty(ref)

  return (
    <div className={className}>
      <Container
        isActive={isSelected}
        size={size}
        onClick={onClick}
        className={clsx(isSelected && 'tw-bg-surface-primary tw-border tw-border-border-secondary')}
        ref={ref}
      >
        <StyledTxt
          sizeType={size === 's' ? 's' : 'm'}
          size={size}
          isActive={isSelected}
          isHovering={isHovering}
          className={clsx(
            isSelected
              ? 'tw-text-roovPrimary-default'
              : isHovering
              ? 'tw-text-standardText-primary'
              : 'tw-text-standardText-secondary'
          )}
        >
          {text}
        </StyledTxt>
      </Container>
    </div>
  )
})
